import React from "react";
import { Typography, SvgIcon, Select as SelectComponent } from "@mui/material";
import { useTheme } from "@mui/material/styles";

type PropsType = {
  label: string;
  disabled?: boolean;
};

const FieldLabel = ({ label, disabled }: PropsType) => {
  const theme = useTheme();
  return (
    <Typography
      color={disabled ? theme.palette.secondary.light : "#fff"}
      fontWeight={700}
      mb={theme.spacing(4)}
    >
      {label}
    </Typography>
  );
};

export default FieldLabel;
